import { ShieldCheck, Lock, Sparkles } from "lucide-react";

export const Logo = ({ light = false }) => (
  <div className="flex items-center gap-2.5" data-testid="app-logo">
    <div className="relative h-9 w-9 rounded-full bg-[#1E3A8A] ring-4 ring-[#D97706]/30 flex items-center justify-center">
      <div className="h-4 w-4 rounded-full border-[3px] border-white" />
    </div>
    <div className="leading-none">
      <div className={`font-display font-extrabold tracking-tight text-[15px] ${light ? "text-white" : "text-slate-900"}`}>SDR PNEUS 91</div>
      <div className={`text-[10px] uppercase tracking-[0.18em] font-semibold ${light ? "text-slate-400" : "text-slate-500"}`}>Documents</div>
    </div>
  </div>
);

const POINTS = [
  { icon: Lock, text: "Données chiffrées en transit et au repos" },
  { icon: ShieldCheck, text: "Accès par rôle, dossier et fichier, journalisé" },
  { icon: Sparkles, text: "Assistant IA limité à vos documents autorisés" },
];

export function AuthLayout({ children }) {
  return (
    <div className="min-h-screen flex">
      <aside className="hidden lg:flex w-[46%] tread-bg relative flex-col justify-between p-12 overflow-hidden">
        <Logo light />
        <div className="relative z-10 max-w-md">
          <p className="text-xs uppercase tracking-[0.2em] text-amber-500 font-semibold mb-4">Espace documentaire sécurisé</p>
          <h1 className="font-display text-4xl xl:text-5xl font-extrabold text-white tracking-tight leading-[1.05]">
            Tous vos documents. Une seule adresse.
          </h1>
          <p className="mt-5 text-slate-300 leading-relaxed">
            Factures fournisseurs, contrats, fiches techniques, documents RH : retrouvez, partagez et analysez chaque document de l'entreprise en quelques secondes.
          </p>
          <ul className="mt-8 space-y-3">
            {POINTS.map(({ icon: I, text }) => (
              <li key={text} className="flex items-center gap-3 text-slate-200 text-sm">
                <span className="h-8 w-8 rounded-md bg-white/10 flex items-center justify-center"><I className="h-4 w-4 text-amber-400" /></span>
                {text}
              </li>
            ))}
          </ul>
        </div>
        <img src="https://images.unsplash.com/photo-1588723071875-2c8c39b51c94?crop=entropy&cs=srgb&fm=jpg&q=70&w=1200"
             alt="" className="absolute -right-24 -bottom-24 w-[70%] opacity-20 rounded-full object-cover aspect-square" />
        <p className="text-xs text-slate-500 relative z-10">© SDR PNEUS 91 — accès réservé aux collaborateurs autorisés</p>
      </aside>
      <main className="flex-1 flex flex-col items-center justify-center p-4 sm:p-8 bg-slate-50">
        <div className="lg:hidden mb-8"><Logo /></div>
        {children}
        <p className="mt-6 text-xs text-slate-500 text-center max-w-sm">
          Une vérification par code email est demandée lors d'une connexion depuis un nouvel appareil.
        </p>
      </main>
    </div>
  );
}
